import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import BRANDS_QUERY from '../queries/BRANDS_QUERY';
 
const useBrands = () => {
    const [ brands, setBrands ] = useState( [] );
    const { data, loading, error } = useQuery( BRANDS_QUERY );

    useEffect( () => {
        if ( loading || error || !data || !data.brands?.edges ) { return; }
        
        try {
            const result = data.brands.edges.map( i => { 
                return {
                    id: i.node?.id || '',
                    key: i.node?.id || '',
                    name: i.node?.name || '', 
                    slug: i.node?.slug || '', 
                    segmentId: i.node?.segmentId || '', 
                }; 
            } );

            setBrands( result );
        } catch ( error ) {
            console.error( 'Error parsing brands', error ); 
            setBrands( [] );
        }
    }, [ loading, error ] );
  
    const getBrand = ( id ) => brands.find( i => i.id === id );
    const getBrandLabel = ( id ) => getBrand( id )?.name || 'Not found';

    return useMemo( () => {
        return {
            brands,
            brandsError: error,
            brandsLoading: loading,
            getBrand,
            getBrandLabel
        };
    }, [ brands, error, loading ] );
};

export default useBrands;
